module.exports = __webpack_public_path__ + "img/masonry-banner-1.2de531cd.jpg";